import { MerchantType, OrdinaryPersonPrefixType } from "@/enums/enums";
import { i18n } from "@/i18n";
import { OrdinaryPersonModel } from "@/model/contact/contactModel";
import {
  MerchantPackageRightApplicationModel,
  MerchantPackageRightModel,
  MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel,
  MerchantPackageRightPeakAccountApplicationAccountsModel,
  MerchantPackageRightPeakAccountApplicationDocumentSettingModel,
  MerchantPackageRightPeakAccountApplicationExpenseModel,
  MerchantPackageRightPeakAccountApplicationFinanceModel,
  MerchantPackageRightPeakAccountApplicationModel,
  MerchantPackageRightPeakAccountApplicationRevenueModel,
  MerchantPackageRightPeakAccountApplicationSettingModel,
  MerchantPackageRightPeakAccountApplicationUserSettingModel,
  MerchantPackageRightPeakAssetApplicationModel,
  MerchantPackageRightPeakTaxApplicationModel,
  SelectedMerchantModel,
  UserRoleInfoModel,
} from "@/model/merchant/selectedMerchantModel";

function GetMerchantPackageRightApplication(applicationRaw: any): MerchantPackageRightApplicationModel {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(
  revenueRaw: any
): MerchantPackageRightPeakAccountApplicationRevenueModel {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(
  expenseRaw: any
): MerchantPackageRightPeakAccountApplicationExpenseModel {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(
  financeRaw: any
): MerchantPackageRightPeakAccountApplicationFinanceModel {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationAccountsModel {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(
  documentRaw: any
): MerchantPackageRightPeakAccountApplicationDocumentSettingModel {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(
  userRaw: any
): MerchantPackageRightPeakAccountApplicationUserSettingModel {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(
  accountingPolicyRaw: any
): MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(
  settingRaw: any
): MerchantPackageRightPeakAccountApplicationSettingModel {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationModel {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw: any): MerchantPackageRightPeakTaxApplicationModel {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw: any): MerchantPackageRightPeakAssetApplicationModel {
  return { totalAsset: assetRaw.totalAsset };
}
function GetMerchantPackageRight(merchantPackageRightRaw: any): MerchantPackageRightModel {
  return {
    application: GetMerchantPackageRightApplication(merchantPackageRightRaw.application),
    account: GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account),
    tax: GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax),
    asset: GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset),
  };
}
function GetRole(userRoleRaw: any): UserRoleInfoModel {
  return {
    authorityRole: userRoleRaw.authorityRole,
    role: userRoleRaw.role,
    manageUser: userRoleRaw.manageUser,
    manageFinance: userRoleRaw.manageFinance,
    isSuperUser: userRoleRaw.isSuperUser,
    isUsePayroll: userRoleRaw.isUsePayroll,
    isUsePeakBoard: userRoleRaw.isUsePeakBoard,
    manageProduct: userRoleRaw.manageProduct,
    isSeeSelfDocuments: userRoleRaw.isSeeSelfDocuments,
    manageFinanceAndJournals: userRoleRaw.manageFinanceAndJournals,
    manageAsset: userRoleRaw.manageAsset,
    manageContact: userRoleRaw.manageContact,
    isViewReport: userRoleRaw.isViewReport,
  };
}
export function GetSelectedMerchant(merchantRaw: any): SelectedMerchantModel {
  return {
    merchantId: merchantRaw.merchantId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
    role: GetRole(merchantRaw.role),
  };
}

export function GetMerchantNameWihtMerchantType(merchantType: number, merchantName: string) {
  let nameType = GetMerchantName(merchantType);

  return nameType.frontName + merchantName + nameType.backName;
}

export function GetMerchantNameWihtOrdinaryPerson(ordinaryPerson: OrdinaryPersonModel, name: string) {
  let prefix = "";
  switch (ordinaryPerson.namePrefixType) {
    case OrdinaryPersonPrefixType.Sir:
      prefix = i18n.t("PrefixName.Khun").toString();
      break;
    case OrdinaryPersonPrefixType.Mr:
      prefix = i18n.t("PrefixName.Mr").toString();
      break;
    case OrdinaryPersonPrefixType.Mrs:
      prefix = i18n.t("PrefixName.Mrs").toString();
      break;
    case OrdinaryPersonPrefixType.Ms:
      prefix = i18n.t("PrefixName.Ms").toString();
      break;
    case OrdinaryPersonPrefixType.Other:
      prefix = ordinaryPerson.namePrefixOther;
      break;
  }

  return prefix + " " + name;
}

export function GetMerchantFullName(
  merchantType: MerchantType,
  contactName: string,
  contactOrdinaryPerson: OrdinaryPersonModel
) {
  let contactFullName = "";
  switch (merchantType) {
    case MerchantType.OrdinaryPerson:
      contactFullName = GetMerchantNameWihtOrdinaryPerson(contactOrdinaryPerson, contactName);
      break;

    default:
      contactFullName = GetMerchantNameWihtMerchantType(merchantType, contactName);
      break;
  }

  return contactFullName;
}

function GetMerchantName(merchantType: number) {
  let frontName = "";
  let backName = "";
  switch (merchantType) {
    case MerchantType.LimitedLiabilityPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนจำกัด " : "";
      backName = i18n.locale == "th" ? "" : " Limited Partnership";
      break;
    case MerchantType.CompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด" : " Company Limited";
      break;
    case MerchantType.PublicCompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด (มหาชน)" : " Public Company Limited";
      break;
    case MerchantType.Shop:
      frontName = i18n.locale == "th" ? "ร้าน " : "";
      backName = i18n.locale == "th" ? "" : " Shop";
      break;
    case MerchantType.OrdinaryPerson:
      frontName = "";
      backName = "";
      break;
    case MerchantType.BodyOfPersons:
      frontName = i18n.locale == "th" ? "คณะบุคคล " : "";
      backName = i18n.locale == "th" ? "" : " Body of Persons";
      break;
    case MerchantType.Others:
      frontName = "";
      backName = "";
      break;
    case MerchantType.OrdinaryPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนสามัญ " : "";
      backName = i18n.locale == "th" ? "" : " Ordinary Partnership";
      break;
    case MerchantType.Foundation:
      frontName = i18n.locale == "th" ? "มูลนิธิ " : "";
      backName = i18n.locale == "th" ? "" : " Foundation";
      break;
    case MerchantType.Association:
      frontName = i18n.locale == "th" ? "สมาคม " : "";
      backName = i18n.locale == "th" ? "" : " Association";
      break;
    case MerchantType.JointVenture:
      frontName = i18n.locale == "th" ? "กิจการร่วมค้า " : "";
      backName = i18n.locale == "th" ? "" : " Joint Venture";
      break;
  }
  return { frontName, backName };
}

export function GetMerchantBranchCode(branchCode: string) {
  const branchName =
    branchCode == "00000" ? ` (${i18n.t("head_quarter")})` : branchCode !== "" ? ` (${branchCode})` : "";
  return branchName;
}

export function GetMerchantFullNameForCertified(
  contactMerchantType: MerchantType,
  contactName: string,
  contactOrdinaryPerson: OrdinaryPersonModel
) {
  const finalName = GetMerchantFullName(contactMerchantType, contactName, contactOrdinaryPerson);
  if (
    contactMerchantType == MerchantType.OrdinaryPerson &&
    contactOrdinaryPerson.namePrefixType != OrdinaryPersonPrefixType.None
  ) {
    const nameSplit = finalName.trim().split(" ");
    const nameTitle = nameSplit.shift();
    return nameTitle + nameSplit.join(" ");
  }
  return finalName;
}
